import { USER_TYPE_DECISION } from "../constants/common.constants"
import { ApiResponse } from "../models/common.model"
import axiosInstance from "../utils/api-util/utilApi"

const config = {
  baseURL: process.env.REACT_APP_MASTER_SETUP_SERVICE_URL || ''
}

export const getDecisionReasonCodes = (decision: string, transactionType: number): Promise<ApiResponse<any>> => {
  return axiosInstance.get(`/api/SystemConfigurations/decisionReasonCodes?decision=${decision}&transactionType=${transactionType}&userType=${USER_TYPE_DECISION}`, config)
}